import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Radio,
  RadioGroup,
} from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CircularProgress from '@mui/material/CircularProgress';
import FileSaver from 'file-saver';
import Swal from 'sweetalert2';
import moment from 'moment';

import CustomHeader from '../../../components/common/header/CustomHeader';
import Sidebar from '../../../components/common/sidebar/Sidebar';
import ExpenseCard from '../ExpenseCard.js/ExpenseCard';
import plusIcon from '../../../assets/promotional-expense/plus.svg';
import OpaqueLoading from '../../../components/common/opaqueLoading/opaqueLoading';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

const Container = styled.div`
  width: 100%;
`;

const DialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
`;

const NotDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 600;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 16px;
  margin: 20px 25px;
  width: 100%;
  height: 100%;
  align-items: stretch;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 650px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

const Block = styled.div`
  margin: 2px 0 2px 0;
`;

const Span = styled.span`
  font-size: 14px;
  font-weight: 400;
`;

const OwnerName = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0%;
  color: #0088cc;
`;

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const fmt = (d) => dayjs(d).format('YYYY-MM-DD');
const toDayjs = (str) => (str ? dayjs(str, 'YYYY-MM-DD') : null);

const ApprovalExpense = () => {
  const debounceTimer = React.useRef(null);
  const fileInputRef = React.useRef(null);

  const [expenses, setExpenses] = useState([]);
  const [selectedExpense, setSelectedExpense] = useState();
  const [eventTeams1, setEventTeams1] = useState([]);
  const [eventTeams2, setEventTeams2] = useState([]);
  const [selectedYear, setSelectedYear] = useState();
  const [selectedMonth, setSelectedMonth] = useState();
  const [selectedExpenseOwner, setSelectedExpenseOwner] = useState();
  const [selectedMonthD, setSelectedMonthD] = useState();
  const [selectedExpenseOwnerD, setSelectedExpenseOwnerD] = useState();
  const [selectedEventOwner, setSelectedEventOwner] = useState();
  const [selectedExpenses, setSelectedExpenses] = useState([]);
  const [sendToApprovalExpenses, setSendToApprovalExpenses] = useState([]);
  const [eventTypes, setEventTypes] = useState([]);
  const [eventType, setEventType] = useState();
  const [eventAmount, setEventAmount] = useState();
  const [approvedAmount, setApprovedAmount] = useState();
  const [remarks, setRemarks] = useState();
  const [date, setDate] = useState();
  const [eventTypeName, setEventTypeName] = useState();
  const [expenseEvents, setExpenseEvents] = useState([]);
  const [expenseEvent, setExpenseEvent] = useState();
  const [expenseEventName, setExpenseEventName] = useState();
  const [expenseSfid, setExpenseSfid] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialog2, setOpenDialog2] = useState(false);
  const [openDialog3, setOpenDialog3] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchLoading1, setSearchLoading1] = useState(false);
  const [searchLoading2, setSearchLoading2] = useState(false);
  const [user, setUser] = useState({});
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState();

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [minDate, setMinDate] = useState(null);
  const [dateRange, setDateRange] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [fortnight, setFortnight] = useState('first');
  const [currentYear, setCurrentYear] = useState(null);

  // const [dateRange, setDateRange] = useState(false);

  const [pageNumber, setPageNumber] = useState(1);
  const [isFetch, setIsFetch] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [spinLoading, setSpinLoading] = useState(false);
  const loaderRef = useRef(null);
  const [auth, setAuth] = useState({});
  const [years, setYears] = useState([]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('storedUserData'));
    if (user) {
      setAuth(user);
    }
  }, []);

  useEffect(() => {
    // apply initial preselected fortnight
    getYearWindow();
    // applyFirstFortnight();
  }, []);

  // useEffect(() => {
  //   if (!selectedMonth) return;
  //   if (fortnight === 'first') applyFirstFortnight(selectedMonth, selectedYear);
  //   else applySecondFortnight(selectedMonth, selectedYear);
  // }, [fortnight]);

  // Month name helpers
  const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const getMonthIndex = (name) => {
    if (!name) return null;
    const idx = MONTHS.findIndex(
      (m) => m.toLowerCase() === String(name).toLowerCase()
    );
    return idx >= 0 ? idx : null;
  };

  const getMonthStart = (monthName, year = dayjs().year()) => {
    const mIdx = getMonthIndex(monthName);
    if (mIdx === null) return null;
    const month = String(mIdx + 1).padStart(2, '0'); // 01..12
    return dayjs(`${year}-${month}-01`); // YYYY-MM-01
  };

  function getYearWindow(date = new Date()) {
    const current = date.getFullYear();
    setYears([current - 1, current, current + 1]);
    return [current - 1, current, current + 1];
  }

  const setRange = (start, end) => {
    const s = dayjs(start);
    const e = dayjs(end);
    setStartDate(fmt(s));
    setEndDate(fmt(e));
    setDateRange(true);
    setMinDate(s);
  };

  const applyFirstFortnight = (selectedMonth, selectedYear) => {
    const monthStart = getMonthStart(
      selectedMonth,
      selectedYear ?? dayjs().year()
    );
    if (!monthStart) return; // guard if month name invalid
    const first15End = monthStart.add(14, 'day'); // 1..15 inclusive
    setRange(monthStart, first15End);
  };

  const applySecondFortnight = (selectedMonth, selectedYear) => {
    const monthStart = getMonthStart(
      selectedMonth,
      selectedYear ?? dayjs().year()
    );
    if (!monthStart) return;
    const secondStart = monthStart.add(15, 'day'); // 16th
    const monthEnd = monthStart.endOf('month'); // 28/29/30/31
    setRange(secondStart, monthEnd);
  };

  const handleFortnightChange = (e) => {
    const val = e.target.value;
    setFortnight(val);
    if (val === 'first') applyFirstFortnight(selectedMonth, selectedYear);
    else if (val === 'second')
      applySecondFortnight(selectedMonth, selectedYear);
  };

  const formatDate = async (data) => {
    setDateRange(true);
    setEndDate(null);

    const start = dayjs(data?.$d ?? data);
    const formattedStartDate = fmt(start);
    setStartDate(formattedStartDate);

    const endDateLimit = start.add(15, 'day');
    setMinDate(start);

    // Optional: keep within 15-day window if manually changing
    // setEndDate(fmt(endDateLimit));
  };

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !spinLoading && hasMore) {
        setPageNumber((prev) => prev + 1);
      }
    });

    const currentLoader = loaderRef.current;
    if (currentLoader) {
      observer.observe(currentLoader);
    }

    return () => {
      if (currentLoader) observer.unobserve(currentLoader);
    };
  }, [spinLoading, hasMore]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('storedUserData'));
    if (user) {
      getCurrentYear();
      getEventRecordTypeId();
      // approvalExpenseList();
      getEventTeams1();
      getEventTeams2();
      getStateData();
      setUser(user);
    } else {
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    if (pageNumber === 1 && isFetch) {
      return;
    }

    if (!isFetch) {
      approvalExpenseList();
    } else {
      handleSubmit2();
    }
  }, [pageNumber]);

  const getCurrentYear = () => {
    const currentYear = new Date().getFullYear();
    setCurrentYear(currentYear);
  };

  // const formatDate = async (data) => {
  //   setDateRange(true);
  //   setEndDate(null);

  //   const start = new Date(data.$d);
  //   const year = start.getFullYear();
  //   const month = String(start.getMonth() + 1).padStart(2, '0');
  //   const day = String(start.getDate()).padStart(2, '0');
  //   const formattedStartDate = `${year}-${month}-${day}`;

  //   setStartDate(formattedStartDate);

  //   const endDateLimit = new Date(start);
  //   endDateLimit.setDate(endDateLimit.getDate() + 15);

  //   setMinDate(dayjs(endDateLimit));
  // };

  const getEventRecordTypeId = async () => {
    try {
      setLoading(true);
      const result = await window.Platform.database.getEventRecordTypeId();
      setEventTypes(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleInputChange = (e) => {
    const approvedAmount =
      typeof Number(e.target.value) === 'number' ? +e.target.value : 0;
    if (approvedAmount <= eventAmount) {
      setApprovedAmount(+e.target.value);
    } else {
      return;
    }
  };

  const handleRemarksChange = (e) => {
    setRemarks(e.target.value);
  };

  const handleExpenseUpdate = async (expense) => {
    setErrors({});
    setSelectedExpense(expense);
    const eventType = eventTypes?.find(
      (eventType) => eventType.eventName === expense.event_type__c
    );
    setEventType(eventType);
    setEventTypeName(eventType.mainEventName);
    const expenseList = await getExpenseEventList(eventType);
    const expenseEvent = expenseList.find(
      (expenseObj) => expenseObj.eventsfid === expense.eventsfid
    );
    setExpenseEvent(expenseEvent);
    setExpenseEventName(expenseEvent?.eventname);
    setExpenseSfid(expense?.expensesfid);
    setEventAmount(expense?.amount__c);
    setApprovedAmount(expense?.approved_amount__c);
    setRemarks(expense?.remarks);
    setDate(expense?.date__c ? dayjs(expense?.date__c) : null);
    setImageUrl(expense?.upload_file__c);
    setOpenDialog(true);
  };

  const getExpenseEventList = async (value) => {
    try {
      const payload = {
        eventType: typeof value === 'object' ? value.value : value,
        searchField: '',
        pageNumber: 1,
      };
      const result = await window.Platform.database.getExpenseEventList(
        payload
      );
      setExpenseEvents(result.data);
      return result.data;
    } catch (error) {
      console.log(error);
    }
  };

  const handleVerify = async (expense) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const heroku_id__c = expense.heroku_id__c;

        const payload = {
          heroku_id__c,
        };

        const result = await window.Platform.database.financeStatusVerified(
          payload
        );

        if (!result.hasError) {
          approvalExpenseList();
          window.NotificationUtils.showSuccess(
            `Expense with herouku id: ${heroku_id__c} has been verified successfully.`
          );
        }
      }
    });
  };

  const approvalExpenseList = async (value = null, type = null) => {
    try {
      if (pageNumber === 1) {
        setIsFetch(false);
      }
      // else if (!hasMore || spinLoading) {
      //   return;
      // }
      else if (spinLoading) {
        return;
      }

      setSpinLoading(true);
      const result = await window.Platform.database.approvalExpenseList({
        year: selectedYear,
        monthName: selectedMonth ? selectedMonth : '',
        expenseOwnerSfid: selectedExpenseOwner?.sfid
          ? selectedExpenseOwner?.sfid
          : type === 'expense owner'
          ? value
          : '',
        eventOwnerSfid: selectedEventOwner?.sfid
          ? selectedEventOwner?.sfid
          : type === 'event owner'
          ? value
          : '',
        pageNumber,
      });

      if (result.data?.length < 20) {
        setHasMore(false);
      }

      if (pageNumber === 1) {
        setExpenses(result.data);
      } else {
        setExpenses((prev) => [...prev, ...result.data]);
      }
      setLoading(false);
      setSpinLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      setSpinLoading(false);
    }
  };

  const getEventTeams1 = async (value = null) => {
    try {
      const result = await window.Platform.database.activityTeams({
        pageNumber: 1,
        searchField: value ? value : '',
      });
      setEventTeams1(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getEventTeams2 = async (value = null) => {
    try {
      const result = await window.Platform.database.activityTeams({
        pageNumber: 1,
        searchField: value ? value : '',
      });
      setEventTeams2(result.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getStateData = async () => {
    try {
      const response = await window.Platform.database.getStates();
      setStates(response.data.filter((item) => item.name__c));
    } catch (error) {
      console.error(error);
    }
  };

  const handleYearChange = async (value) => {
    setSelectedYear(value);

    if (!value) {
      setLoading(true);

      const result = await window.Platform.database.approvalExpenseList({
        stateSfid: selectedState?.sfid || '',
        year: value,
        monthName: selectedMonth,
        expenseOwnerSfid: selectedExpenseOwner?.sfid
          ? selectedExpenseOwner?.sfid
          : '',
        eventOwnerSfid: selectedEventOwner?.sfid
          ? selectedEventOwner?.sfid
          : '',
        pageNumber: 1,
      });

      setPageNumber(1);
      setIsFetch(true);
      setHasMore(true);

      if (result?.data?.length < 20) {
        setHasMore(false);
      }

      setExpenses(result.data);
      setLoading(false);
    }
  };

  const handleMonthChange = async (value) => {
    setSelectedMonth(value);
    if (!value) {
      setLoading(true);

      const result = await window.Platform.database.approvalExpenseList({
        stateSfid: selectedState?.sfid || '',
        year: selectedYear,
        monthName: value,
        expenseOwnerSfid: selectedExpenseOwner?.sfid
          ? selectedExpenseOwner?.sfid
          : '',
        eventOwnerSfid: selectedEventOwner?.sfid
          ? selectedEventOwner?.sfid
          : '',
        pageNumber: 1,
      });

      setPageNumber(1);
      setIsFetch(true);
      setHasMore(true);

      if (result?.data?.length < 20) {
        setHasMore(false);
      }

      setExpenses(result.data);
      setLoading(false);
    }
  };

  const handleStateChange = async (value) => {
    setSelectedState(value);
    if (!value) {
      setLoading(true);

      const result = await window.Platform.database.approvalExpenseList({
        stateSfid: value?.sfid || '',
        year: selectedYear,
        monthName: selectedMonth,
        expenseOwnerSfid: selectedExpenseOwner?.sfid
          ? selectedExpenseOwner?.sfid
          : '',
        eventOwnerSfid: selectedEventOwner?.sfid
          ? selectedEventOwner?.sfid
          : '',
        pageNumber: 1,
      });

      setPageNumber(1);
      setIsFetch(true);
      setHasMore(true);

      if (result?.data?.length < 20) {
        setHasMore(false);
      }

      setExpenses(result.data);
      setLoading(false);
    }
  };

  const handleExpenseOwnerChange = async (value) => {
    setSelectedExpenseOwner(value);
    if (!value) {
      setSearchLoading1(true);

      const result = await window.Platform.database.approvalExpenseList({
        stateSfid: selectedState?.sfid || '',
        year: selectedYear,
        monthName: selectedMonth,
        expenseOwnerSfid: value,
        eventOwnerSfid: selectedEventOwner?.sfid
          ? selectedEventOwner?.sfid
          : '',
        pageNumber: 1,
      });

      setPageNumber(1);
      setIsFetch(true);
      setHasMore(true);

      if (result?.data?.length < 20) {
        setHasMore(false);
      }

      setExpenses(result.data);
      setSearchLoading1(false);
    }
  };

  const handleMonthDChange = async (value) => {
    setSelectedMonthD(value);
  };

  const handleExpenseOwnerDChange = async (value) => {
    setSelectedExpenseOwnerD(value);
  };

  const handleEventOwnerChange = async (value) => {
    setSelectedEventOwner(value);
    if (!value) {
      setSearchLoading2(true);

      const result = await window.Platform.database.approvalExpenseList({
        stateSfid: selectedState?.sfid || '',
        year: selectedYear,
        monthName: selectedMonth,
        expenseOwnerSfid: selectedExpenseOwner?.sfid
          ? selectedExpenseOwner?.sfid
          : '',
        eventOwnerSfid: value,
        pageNumber: 1,
      });

      setPageNumber(1);
      setIsFetch(true);
      setHasMore(true);

      if (result?.data?.length < 20) {
        setHasMore(false);
      }

      setExpenses(result.data);
      setSearchLoading2(false);
    }
  };

  const handleClose = () => {
    setOpenDialog(false);
    setEventType(null);
    setEventAmount(null);
    setDate(null);
    setEventTypeName(null);
    setExpenseEvent(null);
    setImageUrl(null);
  };

  const handleClose3 = () => {
    setFortnight('first');
    setOpenDialog3(false);
  };

  const handleSubmit2 = async (isCalled = false) => {
    try {
      // if (isCalled) {
      //   setPageNumber(1);
      //   setIsFetch(true);
      //   setHasMore(true);
      // } else if (!hasMore || spinLoading) {
      //   return;
      // }

      setLoading(true);
      const result = await window.Platform.database.approvalExpenseList({
        stateSfid: selectedState?.sfid || '',
        year: selectedYear,
        monthName: selectedMonth,
        expenseOwnerSfid: selectedExpenseOwner?.sfid
          ? selectedExpenseOwner?.sfid
          : '',
        eventOwnerSfid: selectedEventOwner?.sfid
          ? selectedEventOwner?.sfid
          : '',
        pageNumber: isCalled ? 1 : pageNumber,
      });

      if (result.data?.length < 20) {
        setHasMore(false);
      }

      if (isCalled) {
        setPageNumber(1);
        setIsFetch(true);
        // setHasMore(true);
      } else if (!hasMore || spinLoading) {
        return;
      }

      if (isCalled) {
        setExpenses(result.data);
      } else {
        setExpenses((prev) => [...prev, ...result.data]);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const validateForm = (data) => {
    const errors = {};

    if (!Number(data['approved_amount__c'])) {
      errors['approved_amount__c'] = 'Amount cannot be zero or empty.';
    }

    return errors;
  };

  const handleSubmit = async () => {
    setLoading(true);
    const payload = {
      eventType: eventType?.eventName,
      Formated_Event_Name__c: `${
        expenseEventName
          ? eventTypeName + '(' + expenseEventName + ')'
          : eventTypeName
      }`,
      eventId: selectedExpense?.eventsfid,
      Amount__c: eventAmount,
      approved_amount__c: approvedAmount,
      date__c: selectedExpense.date__c,
      files__c: imageUrl?.url ? imageUrl?.url : selectedExpense?.upload_file__c,
      expenseSfid: expenseSfid,
      remarks,
    };

    try {
      const errors = validateForm(payload);
      setErrors(errors);

      if (Object.keys(errors).length === 0) {
        const result = await window.Platform.database.updateExpenseById(
          payload
        );
        if (result.hasError) {
          window.NotificationUtils.showError(result.message);
          throw new Error(`Update expense failed.`);
        }

        window.NotificationUtils.showSuccess(
          `Expense has been updated successfully`
        );
        setEventType(null);
        setEventAmount(null);
        setApprovedAmount(null);
        setDate(null);
        setEventTypeName(null);
        setRemarks(null);
        setExpenseEvent(null);
        setImageUrl(null);
        setOpenDialog(false);

        const result2 = await window.Platform.database.approvalExpenseList({
          monthName: selectedMonth,
          expenseOwnerSfid: selectedExpenseOwner?.sfid
            ? selectedExpenseOwner?.sfid
            : '',
          eventOwnerSfid: selectedEventOwner?.sfid
            ? selectedEventOwner?.sfid
            : '',
        });
        setExpenses(result2.data);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error during form submission:', error);
      setLoading(false);
      alert(`${error.message}`);
    }
  };

  const debouncedSearchField = (event, name) => {
    const { value } = event.target;

    if (value.length !== 0) {
      if (value.length <= 3) {
        return;
      }
    }

    clearTimeout(debounceTimer.current);

    if (name === 'Expense Owner') {
      setSearchLoading1(true);
      setEventTeams1([]);
      setSelectedExpenseOwner(value);
    } else {
      setSearchLoading2(true);
      setEventTeams2([]);
      setSelectedEventOwner(value);
    }

    debounceTimer.current = setTimeout(() => {
      const conditionalObject = {
        'Expense Owner': () => getEventTeams1(value, 'expense owner'),
        'Event Owner': () => getEventTeams2(value, 'event owner'),
      };

      conditionalObject[name]();
      setSearchLoading1(false);
      setSearchLoading2(false);
    }, 1500);
  };

  const handleExpenseCheck = (event) => {
    if (event.target.checked) {
      const allExpenseIds = expenses.map((e) => e.expensesfid);
      setSelectedExpenses(allExpenseIds);
      const expenseList = expenses.map((p) => {
        return {
          expenseSfid: p.expensesfid,
          Amount__c: p.amount__c,
          approved_amount__c: p.approved_amount__c,
          eventsfid: p.eventsfid,
          expenseCreatedUserProfile: p.profile__c,
        };
      });
      setSendToApprovalExpenses(expenseList);
    } else {
      setSelectedExpenses([]);
      setSendToApprovalExpenses([]);
    }
  };

  const handleCheck = (e, expense) => {
    if (e.target.checked) {
      setSelectedExpenses((prev) => [...prev, expense.expensesfid]);
      setSendToApprovalExpenses((prev) => {
        return [
          ...prev,
          {
            expenseSfid: expense.expensesfid,
            Amount__c: expense.amount__c,
            approved_amount__c: expense.approved_amount__c,
            eventsfid: expense.eventsfid,
            expenseCreatedUserProfile: expense.profile__c,
          },
        ];
      });
    } else {
      setSelectedExpenses((prev) =>
        prev.filter((item) => item !== expense.expensesfid)
      );
      setSendToApprovalExpenses((prev) => {
        const filteredList = prev.filter(
          (item) => item.expenseSfid !== expense.expensesfid
        );
        return filteredList;
      });
    }
  };

  const handleApprovalExpensesSubmit = async (isApproved) => {
    setLoading(true);
    try {
      if (sendToApprovalExpenses.length === 0) {
        window.NotificationUtils.showError(
          `Please select atleast an expense before submit.`
        );
        setLoading(false);
        return;
      }

      const result = await window.Platform.database.submitExpenseApproval({
        paramsData: sendToApprovalExpenses,
        isApproved: isApproved,
      });
      if (result.hasError)
        throw new Error(
          `Expenses ${isApproved ? 'approval' : 'rejection'} failed.`
        );
      window.NotificationUtils.showSuccess(
        `Expense has been ${isApproved ? 'approved' : 'rejected'} successfully`
      );
      setSendToApprovalExpenses([]);
      setSelectedExpenses([]);
      approvalExpenseList();
    } catch (error) {
      alert(`${error.message}`);
      setLoading(false);
    }
  };

  const handleDownloadExpenses = () => {
    // setSelectedMonthD('');
    // setSelectedExpenseOwnerD('');
    setStartDate(null);
    setEndDate(null);
    if (selectedMonth && selectedYear) {
      setOpenDialog3(true);
      applyFirstFortnight(selectedMonth, selectedYear);
    } else {
      window.NotificationUtils.showError(
        "Please select year and month to see it's fortnight."
      );
    }
  };

  function parseDMYtoDate(dmy) {
    if (typeof dmy !== 'string') return null;
    const [dd, mm, yyyy] = dmy.split('-').map(Number);
    if (!yyyy || !mm || !dd) return null;
    const d = new Date(yyyy, mm - 1, dd);

    if (
      d.getFullYear() !== yyyy ||
      d.getMonth() !== mm - 1 ||
      d.getDate() !== dd
    )
      return null;
    return d;
  }

  function formatDateForCSV(d) {
    if (!(d instanceof Date) || isNaN(d)) return '';
    // return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
    return `${pad2(d.getDate())}.${pad2(d.getMonth() + 1)}.${d.getFullYear()}`;
  }

  const pad2 = (n) => String(n).padStart(2, '0');

  // async function downloadReportInChunks() {
  //   const pageSize = 20;
  //   let pageNumber = 1;
  //   let allData = [];
  //   let hasMore = true;

  //   const payloadPart = {
  //     startDate,
  //     endDate,
  //   };

  //   if (!startDate) {
  //     window.NotificationUtils.showError(
  //       'To download the expense report, please choose start date.'
  //     );
  //     return;
  //   }

  //   if (!endDate) {
  //     window.NotificationUtils.showError(
  //       'To download the expense report, please choose end date.'
  //     );
  //     return;
  //   }

  //   setOpenDialog3(false);

  //   try {
  //     setLoading(true);
  //     while (hasMore) {
  //       const pagedParams = {
  //         ...payloadPart,
  //         pageNumber: pageNumber,
  //       };
  //       const response = await window.Platform.database.downLoadExpense(
  //         pagedParams
  //       );
  //       const currentPageData = response.data || [];

  //       const result = currentPageData.map((item, index) => {
  //         const d = parseDMYtoDate(item.date__c);
  //         const expCreationDate = formatDateForCSV(d);

  //         const csvObj = {
  //           'S No.': index + 1,
  //           'Employee SAP Code': item.employee_id__c,
  //           'Exp. Creation Date': expCreationDate,
  //           'Header Text': item.header_text__c,
  //           'Posting Date': item.posting_date__c,
  //           Currency: item.currency__c,
  //           'Businss Place': item.businss_place__c,
  //           Section: item.section__c,
  //           'Total Date Exp.': 0,
  //           'GL Account': item.gl_account__c,
  //           'Event Name': item.eventtype ?? '',
  //           'Event Exp Amount': item.total_amount,
  //           'Cost Center': item.cost_center__c,
  //           Plant: item.plant_name__c,
  //           'HSN Code': item.hsn_code__c,
  //           'Line Item Text': item.line_item_text__c,
  //         };

  //         return csvObj;
  //       });

  //       allData.push(...result);
  //       hasMore = result.length === pageSize;

  //       pageNumber += 1;
  //     }

  //     const sumWithInitial = allData.reduce(
  //       (accumulator, currentValue) =>
  //         accumulator + currentValue['Event Exp Amount'],
  //       0
  //     );

  //     const finalData = allData.map((item) => {
  //       const it = { ...item, 'Total Date Exp.': sumWithInitial };
  //       return it;
  //     });

  //     generateCSV(finalData, 'Expense Report');
  //     setLoading(false);
  //   } catch (err) {
  //     console.error('Error fetching report:', err);
  //     setLoading(false);
  //   }
  // }

  async function downloadReportInChunks() {
    const pageSize = 20;
    let pageNumber = 1;
    let allData = [];
    let hasMore = true;

    const payloadPart = {
      startDate,
      endDate,
    };

    if (!startDate) {
      window.NotificationUtils.showError(
        'To download the expense report, please choose start date.'
      );
      return;
    }

    if (!endDate) {
      window.NotificationUtils.showError(
        'To download the expense report, please choose end date.'
      );
      return;
    }

    setFortnight('first');
    setOpenDialog3(false);

    try {
      setLoading(true);
      while (hasMore) {
        const pagedParams = {
          ...payloadPart,
          year: selectedYear,
          monthName: selectedMonth,
          expenseOwnerSfid: selectedExpenseOwner?.sfid,
          eventOwnerSfid: selectedEventOwner?.sfid,
          stateSfid: selectedState?.sfid,
          // pageNumber: pageNumber,
        };

        const response = await window.Platform.database.downLoadExpense(
          pagedParams
        );
        const currentPageData = response.data || [];

        const result = currentPageData.map((item) => {
          const d = parseDMYtoDate(item.date__c);
          const expCreationDate = formatDateForCSV(d);

          let d2, expCreationDate2;
          if (item?.posting_date__c) {
            d2 = parseDMYtoDate(item?.posting_date__c);
            expCreationDate2 = formatDateForCSV(d2);
          }

          console.log(item, item.claimid);

          return {
            'S No.': 0, // placeholder
            'Header Text': item?.expenseid,
            'Claim ID': item?.claimid,
            'Employee SAP Code': item.employee_id__c,
            'Exp. Creation Date': expCreationDate,
            // 'Header Text': item.header_text__c,
            'Posting Date': expCreationDate2 || '',
            Currency: item.currency__c,
            'Businss Place': item.businss_place__c,
            Section: item.section__c,
            'Total Date Exp.': 0, // placeholder
            'GL Account': item.gl_account__c,
            'Event Name': item.eventtype || '',
            'Event Exp Amount': item.total_amount,
            'Cost Center': item.cost_center__c,
            Plant: item.plant_name__c,
            'HSN Code': item.hsn_code__c,
            'Line Item Text': item.line_item_text__c,
          };
        });

        allData.push(...result);
        hasMore = result.length === pageSize;
        pageNumber += 1;
      }

      // Group by 'Exp. Creation Date' + 'Employee SAP Code'
      const groupedMap = new Map();

      allData.forEach((item) => {
        const key = `${item['Exp. Creation Date']}|${item['Employee SAP Code']}`;
        if (!groupedMap.has(key)) {
          groupedMap.set(key, { total: 0, items: [] });
        }
        const group = groupedMap.get(key);
        group.total += item['Event Exp Amount'];
        group.items.push(item);
      });

      // Flatten grouped data and assign same S No. and Total Date Exp.
      let serial = 1;
      const finalData = [];

      groupedMap.forEach((group) => {
        group.items.forEach((item) => {
          finalData.push({
            ...item,
            'S No.': serial,
            'Total Date Exp.': group.total,
          });
        });
        serial++;
      });

      generateCSV(finalData, 'Expense Report');
      setLoading(false);
    } catch (err) {
      console.error('Error fetching report:', err);
      setLoading(false);
    }
  }

  async function generateCSV(data, fileName) {
    if (!data || data.length === 0) {
      window.NotificationUtils.showError(
        'The report currently contains no data available for download.'
      );
      return;
    }

    const chunkSize = 500;

    const headers = [
      'S No.',
      'Header Text',
      'Claim ID',
      'Employee SAP Code',
      'Exp. Creation Date',
      // 'Header Text',
      'Posting Date',
      'Currency',
      'Business Place',
      'Section',
      'Total Date Exp.',
      'GL Account',
      'Event Name',
      'Event Exp Amount',
      'Cost Center',
      'Plant',
      'HSN Code',
      'Line Item Text',
    ];

    let csvContent = '';

    // Add headers
    csvContent += headers.join(',') + '\n';

    let index = 0;
    while (index < data.length) {
      const chunk = data.slice(index, index + chunkSize);

      chunk.forEach((item) => {
        const row = headers.map((header) => {
          let cell = item[header];

          if (typeof cell === 'string') {
            cell = `"${cell.replace(/"/g, '""')}"`;
          }

          return cell ?? '';
        });

        csvContent += row.join(',') + '\n';
      });

      index += chunkSize;
      await new Promise((resolve) => setTimeout(resolve, 0));
    }

    try {
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const date = moment().format('DD-MM-YYYY hhmmss A');
      FileSaver.saveAs(blob, `${fileName} on ${date}.csv`);
      window.NotificationUtils.showSuccess(
        'Success! Your report has been downloaded.'
      );
    } catch (error) {
      console.error('Error while generating the CSV file:', error);
    }
  }

  // async function generateCSV(data, fileName) {
  //   if (!data || data.length === 0) {
  //     window.NotificationUtils.showError(
  //       'The report currently contains no data available for download.'
  //     );
  //     return;
  //   }

  //   const chunkSize = 500;
  //   const headersPart1 = ['SAP Employee ID', 'Employee Name', 'Date', 'State'];
  //   const headersPart2 = eventTypes.map((eT) => eT.eventName);
  //   const headersPart3 = ['Total'];

  //   const headers = [...headersPart1, ...headersPart2, ...headersPart3];

  //   let csvContent = '';

  //   // Add headers
  //   csvContent += headers.join(',') + '\n';

  //   let index = 0;
  //   while (index < data.length) {
  //     const chunk = data.slice(index, index + chunkSize);

  //     chunk.forEach((item) => {
  //       let total = 0;

  //       const row = headers.map((header) => {
  //         let cell = item[header];

  //         // Calculate total only for numeric values (excluding dates and strings)
  //         if (typeof cell === 'number' && !isNaN(cell)) {
  //           total += cell;
  //         }

  //         if (typeof cell === 'string') {
  //           cell = `"${cell.replace(/"/g, '""')}"`; // Escape quotes
  //         }

  //         return cell ?? '';
  //       });

  //       // Replace the last column (Total) with the computed total
  //       row[row.length - 1] = total;

  //       csvContent += row.join(',') + '\n';
  //     });

  //     index += chunkSize;
  //     await new Promise((resolve) => setTimeout(resolve, 0));
  //   }

  //   try {
  //     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  //     const date = moment().format('DD-MM-YYYY hhmmss A');
  //     FileSaver.saveAs(blob, `${fileName} on ${date}.csv`);
  //     window.NotificationUtils.showSuccess(
  //       'Success! Your report has been downloaded.'
  //     );
  //   } catch (error) {
  //     console.error('Error while generating the CSV file:', error);
  //   }
  // }

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        backgroundColor: '#F6F6F6',
        minHeight: '100vh',
      }}
    >
      <Sidebar />
      <Container>
        {loading && <OpaqueLoading />}
        <CustomHeader name='expense' />
        <Box
          p={4}
          style={{
            position: 'sticky',
            top: '60px',
            backgroundColor: '#F6F6F6',
            zIndex: 99,
          }}
        >
          <Box
            style={{ width: '100%' }}
            display='flex'
            flexDirection='row'
            flexWrap='wrap'
            alignItems='center'
            justifyContent='space-between'
            gap='10px'
          >
            <FlexContainer
              style={{
                gap: '10px',
                flexWrap: 'wrap',
                justifyContent: 'flex-start',
              }}
            >
              {user?.profile__c !== 'Finance' ? (
                <>
                  <FormControlLabel
                    control={<Checkbox onClick={handleExpenseCheck} />}
                    label='Select All'
                    sx={{ m: 0 }}
                  />
                  <Button
                    variant='outlined'
                    onClick={() => handleApprovalExpensesSubmit(true)}
                  >
                    Approve
                  </Button>
                  <Button
                    variant='outlined'
                    color='error'
                    onClick={() => handleApprovalExpensesSubmit(false)}
                  >
                    Reject
                  </Button>
                </>
              ) : (
                <Button
                  variant='outlined'
                  onClick={() => handleDownloadExpenses()}
                >
                  Download Expense Report
                </Button>
              )}
            </FlexContainer>

            <FlexContainer
              style={{ flexWrap: 'wrap', justifyContent: 'flex-start' }}
            >
              <FormControl style={{ width: '180px' }} size='small'>
                <Autocomplete
                  size='small'
                  value={selectedState || null}
                  onChange={(event, newValue) => handleStateChange(newValue)}
                  options={states}
                  getOptionLabel={(option) => option.name__c || ''}
                  isOptionEqualToValue={(option, value) => {
                    if (!value) return false;
                    return option.sfid === value.sfid;
                  }}
                  fullWidth
                  autoComplete='off'
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label='Select State'
                      slotProps={{
                        input: {
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        },
                      }}
                    />
                  )}
                  filterOptions={(options, { inputValue }) => {
                    return options.filter((option) =>
                      option?.name__c
                        ?.toLowerCase()
                        .startsWith(inputValue?.toLowerCase())
                    );
                  }}
                />
              </FormControl>

              <FormControl style={{ width: '180px' }} size='small'>
                <Autocomplete
                  size='small'
                  value={selectedYear || null}
                  onChange={(event, newValue) => handleYearChange(newValue)}
                  options={years}
                  getOptionLabel={(option) => option}
                  isOptionEqualToValue={(option, value) => option === value}
                  fullWidth
                  autoComplete='off'
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label='Select Year'
                      slotProps={{
                        input: {
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        },
                      }}
                    />
                  )}
                  filterOptions={(options, { inputValue }) => {
                    return options.filter((option) =>
                      option
                        ?.toString()
                        ?.toLowerCase()
                        ?.includes(inputValue?.toString()?.toLowerCase())
                    );
                  }}
                />
              </FormControl>

              <FormControl style={{ width: '180px' }} size='small'>
                <Autocomplete
                  size='small'
                  value={selectedMonth || null}
                  onChange={(event, newValue) => handleMonthChange(newValue)}
                  options={months}
                  getOptionLabel={(option) => option}
                  isOptionEqualToValue={(option, value) => option === value}
                  fullWidth
                  autoComplete='off'
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label='Select Month'
                      slotProps={{
                        input: {
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        },
                      }}
                    />
                  )}
                  filterOptions={(options, { inputValue }) => {
                    return options.filter((option) =>
                      option?.toLowerCase().includes(inputValue?.toLowerCase())
                    );
                  }}
                />
              </FormControl>

              <FormControl style={{ width: '180px' }} size='small'>
                <Autocomplete
                  size='small'
                  value={selectedExpenseOwner || null}
                  onChange={(event, newValue) =>
                    handleExpenseOwnerChange(newValue)
                  }
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === 'clear') {
                      getEventTeams1();
                      return;
                    }
                  }}
                  options={eventTeams1}
                  getOptionLabel={(option) =>
                    typeof option === 'string' ? option : option?.name__c || ''
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.name__c === value
                  }
                  fullWidth
                  autoComplete='off'
                  loading={searchLoading1}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label='Expense Owner'
                      onChange={(event) =>
                        debouncedSearchField(event, 'Expense Owner')
                      }
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {searchLoading1 && (
                              <CircularProgress color='inherit' size={20} />
                            )}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  filterOptions={(options, state) => {
                    return options.filter((option) =>
                      option.name__c?.toLowerCase()
                    );
                  }}
                />
              </FormControl>

              <FormControl style={{ width: '180px' }} size='small'>
                <Autocomplete
                  size='small'
                  value={selectedEventOwner || null}
                  onChange={(event, newValue) =>
                    handleEventOwnerChange(newValue)
                  }
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === 'clear') {
                      getEventTeams2();
                      return;
                    }
                  }}
                  options={eventTeams2}
                  getOptionLabel={(option) =>
                    typeof option === 'string' ? option : option?.name__c || ''
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.name__c === value
                  }
                  fullWidth
                  autoComplete='off'
                  loading={searchLoading2}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label='Event Owner'
                      onChange={(event) =>
                        debouncedSearchField(event, 'Event Owner')
                      }
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {searchLoading2 && (
                              <CircularProgress color='inherit' size={20} />
                            )}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  filterOptions={(options, state) => {
                    return options.filter((option) =>
                      option.name__c?.toLowerCase()
                    );
                  }}
                />
              </FormControl>

              <Button variant='contained' onClick={() => handleSubmit2(true)}>
                Fetch
              </Button>
            </FlexContainer>
          </Box>
        </Box>

        {expenses.length > 0 ? (
          <Grid container spacing={2} padding={2} pt={0}>
            <GridContainer>
              {expenses.map((expense, index) => {
                return (
                  <ExpenseCard
                    // key={expense.event_heroku_id__c}
                    key={index}
                    expense={expense}
                    handleCheck={handleCheck}
                    selectedExpenses={selectedExpenses}
                    handleExpenseUpdate={handleExpenseUpdate}
                    handleVerify={handleVerify}
                    type='approval'
                    user={user}
                    auth={auth}
                  />
                );
              })}
            </GridContainer>
          </Grid>
        ) : (
          <NotDiv>No Data Found</NotDiv>
        )}

        <Dialog
          open={openDialog}
          onClose={handleClose}
          sx={{
            '& .MuiPaper-root.MuiDialog-paper': {
              borderRadius: '16px',
              padding: '24px',
              boxShadow:
                'rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px',
              width: '600px',
            },
            '& .MuiBackdrop-root': {
              backgroundColor: 'transparent',
              backdropFilter: 'blur(1px)',
            },
          }}
        >
          <DialogTitle>
            <IconButton
              onClick={handleClose}
              style={{ position: 'absolute', top: 8, right: 8 }}
            >
              <GridCloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent style={{ paddingTop: '5px' }}>
            <DialogContainer>
              <FormControl fullWidth>
                <InputLabel id='select-label'>Event Type</InputLabel>
                <Select
                  sx={{ borderRadius: '10px' }}
                  labelId='select-label'
                  label='Event Type'
                  value={eventType}
                  disabled
                  required
                  error={Boolean(errors.eventType)}
                >
                  {eventTypes.map((item) => (
                    <MenuItem
                      name={item.mainEventName}
                      value={item}
                      key={item?.mainEventName}
                    >
                      {item.mainEventName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id='select-label'>Event ID</InputLabel>
                <Select
                  sx={{ borderRadius: '10px' }}
                  labelId='select-label'
                  label='Event ID'
                  value={selectedExpense?.eventsfid}
                  disabled
                  InputLabelProps={{
                    shrink: selectedExpense?.eventsfid,
                  }}
                  // required
                  // error={Boolean(errors.eventId)}
                >
                  <MenuItem value={selectedExpense?.eventsfid}>
                    {selectedExpense?.formated_event_name__c}
                    {/* (
                    {selectedExpense?.eventsfid}) */}
                  </MenuItem>
                </Select>
              </FormControl>
              <Box>
                <Block>
                  <Span>Event Owner: </Span>
                  <OwnerName>
                    {selectedExpense?.event_owner_name}-
                    {selectedExpense?.territoryname}
                  </OwnerName>
                </Block>
              </Box>
              <TextField
                sx={{ width: '100%', borderRadius: '10px' }}
                id='field-input'
                label={`Event Amount`}
                variant='outlined'
                value={eventAmount}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                slotProps={{
                  textField: {
                    sx: {
                      borderRadius: '10px',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                      },
                    },
                  },
                }}
              />

              <TextField
                sx={{ width: '100%', borderRadius: '10px' }}
                id='field-input'
                label={`Current Approved Amount`}
                variant='outlined'
                value={approvedAmount}
                onInput={(e) => {
                  // Restrict to numbers only
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={handleInputChange}
                required
                error={Boolean(errors.approved_amount__c)}
                slotProps={{
                  textField: {
                    sx: {
                      borderRadius: '10px',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                      },
                    },
                  },
                }}
              />

              {selectedExpense?.profile__c === 'SI' &&
                selectedExpense?.rm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`RM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.rm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'AM' &&
                selectedExpense?.rm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`RM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.rm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'SI' &&
                selectedExpense?.rmm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`RMM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.rmm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'AM' &&
                selectedExpense?.rmm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`RMM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.rmm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'SI' &&
                selectedExpense?.zm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`ZM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.zm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'AM' &&
                selectedExpense?.zm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`ZM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.zm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'RM' &&
                selectedExpense?.zm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`ZM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.zm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'RM' &&
                selectedExpense?.vp_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`VP Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.vp_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'RM' &&
                selectedExpense?.sfdc_level1_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`SFDC Level 1 Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.sfdc_level1_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'RMM' &&
                selectedExpense?.sfdc_level1_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`SFDC Level 1 (Amit Joshi) Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.sfdc_level1_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'ZM' &&
                selectedExpense?.sfdc_level2_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`SFDC Level 1 (Sood Sir) Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.sfdc_level2_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label='Date'
                  value={
                    selectedExpense?.date__c
                      ? dayjs(selectedExpense?.date__c, 'DD-MM-YYYY')
                      : null
                  }
                  format='YYYY-MM-DD'
                  disabled
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      sx: {
                        width: '100%',
                        borderRadius: '10px',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '10px',
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>

              <div style={{ position: 'relative', width: '100%' }}>
                <TextField
                  sx={{ width: '100%', borderRadius: '10px' }}
                  id='field-input-image'
                  variant='outlined'
                  value={
                    !imageUrl || imageUrl === 'undefined' || imageUrl === 'null'
                      ? 'Image is not available'
                      : imageUrl
                  }
                  disabled
                  slotProps={{
                    textField: {
                      sx: {
                        borderRadius: '10px',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '10px',
                        },
                      },
                    },
                  }}
                />
                {/* <img
                  style={{
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: '#FFF',
                  }}
                  src={plusIcon}
                  alt='File Upload'
                  width={20}
                  height={20}
                /> */}
                {/* <VisibilityIcon
                  sx={{
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: '#FFF',
                    color:
                      !imageUrl ||
                      imageUrl === 'undefined' ||
                      imageUrl === 'null'
                        ? 'grey.400'
                        : 'primary.main',
                    pointerEvents:
                      !imageUrl ||
                      imageUrl === 'undefined' ||
                      imageUrl === 'null'
                        ? 'none'
                        : 'auto',
                    '&:hover': {
                      cursor:
                        !imageUrl ||
                        imageUrl === 'undefined' ||
                        imageUrl === 'null'
                          ? 'default'
                          : 'pointer',
                    },
                  }}
                  onClick={() => {
                    if (
                      imageUrl &&
                      imageUrl !== 'undefined' &&
                      imageUrl !== 'null'
                    ) {
                      setOpenDialog2(true);
                    } else {
                      window.NotificationUtils?.showError?.(
                        'Image not available'
                      );
                    }
                  }}
                /> */}

                <Dialog
                  open={openDialog2}
                  onClose={() => setOpenDialog2(false)}
                  maxWidth='md'
                  fullWidth
                >
                  <DialogTitle>Preview</DialogTitle>
                  <DialogContent dividers>
                    {imageUrl?.toLowerCase().endsWith('.pdf') ? (
                      <iframe
                        src={imageUrl}
                        title='PDF Preview'
                        style={{
                          width: '100%',
                          height: '80vh',
                          border: 'none',
                        }}
                      />
                    ) : (
                      <img
                        src={imageUrl}
                        alt='Preview'
                        style={{
                          maxWidth: '100%',
                          maxHeight: '80vh',
                          display: 'block',
                          margin: '0 auto',
                        }}
                      />
                    )}
                  </DialogContent>
                </Dialog>
              </div>
              <TextField
                sx={{ width: '100%', borderRadius: '10px' }}
                id='field-input'
                label={`Remarks`}
                variant='outlined'
                value={
                  remarks === 'null' || remarks === 'undefined' ? '' : remarks
                }
                InputLabelProps={{
                  shrink: remarks,
                }}
                onChange={handleRemarksChange}
                slotProps={{
                  textField: {
                    sx: {
                      borderRadius: '10px',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                      },
                    },
                  },
                }}
              />

              <FlexContainer
                style={{ justifyContent: 'center', width: '100%', gap: 30 }}
              >
                <Button variant='outlined' onClick={handleClose}>
                  Cancel
                </Button>
                <Button variant='contained' onClick={handleSubmit}>
                  Update
                </Button>
              </FlexContainer>
            </DialogContainer>
          </DialogContent>
        </Dialog>

        <Dialog
          open={openDialog3}
          onClose={handleClose3}
          sx={{
            '& .MuiPaper-root.MuiDialog-paper': {
              borderRadius: '16px',
              padding: '24px',
              boxShadow:
                'rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px',
              width: '400px',
            },
            '& .MuiBackdrop-root': {
              backgroundColor: 'transparent',
              backdropFilter: 'blur(1px)',
            },
          }}
        >
          <DialogTitle>
            <IconButton
              onClick={handleClose3}
              style={{ position: 'absolute', top: 8, right: 8 }}
            >
              <GridCloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent style={{ paddingTop: '5px' }}>
            <DialogContainer>
              {/* <FormControl fullWidth>
                <Autocomplete
                  size='small'
                  value={selectedMonthD || null}
                  onChange={(event, newValue) => handleMonthDChange(newValue)}
                  options={months}
                  getOptionLabel={(option) => option}
                  isOptionEqualToValue={(option, value) => option === value}
                  fullWidth
                  autoComplete='off'
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label='Select Month'
                      slotProps={{
                        input: {
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        },
                      }}
                    />
                  )}
                  filterOptions={(options, { inputValue }) => {
                    return options.filter((option) =>
                      option.toLowerCase().includes(inputValue.toLowerCase())
                    );
                  }}
                />
              </FormControl> */}

              {/* <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label='Start Date*'
                    value={startDate ? dayjs(startDate, 'YYYY-MM-DD') : null}
                    format='YYYY/MM/DD'
                    onChange={(data) => formatDate(data)}
                    disableFuture={false}
                    sx={{ width: '100%' }}
                  />
                </LocalizationProvider>
              </FormControl>

              <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label='End Date*'
                    value={endDate ? dayjs(endDate, 'YYYY-MM-DD') : null}
                    disabled={!dateRange || loading}
                    format='YYYY/MM/DD'
                    minDate={minDate}
                    maxDate={minDate}
                    onChange={(data) => {
                      const selected = new Date(data.$d);
                      const formatted = `${selected.getFullYear()}-${String(
                        selected.getMonth() + 1
                      ).padStart(2, '0')}-${String(selected.getDate()).padStart(
                        2,
                        '0'
                      )}`;
                      setEndDate(formatted);
                    }}
                    disableFuture={false}
                    sx={{ width: '100%' }}
                  />
                </LocalizationProvider>
              </FormControl> */}

              <FormControl fullWidth sx={{ mb: 2 }}>
                <RadioGroup
                  row
                  name='fortnight'
                  value={fortnight}
                  onChange={handleFortnightChange}
                >
                  <FormControlLabel
                    value='first'
                    control={<Radio />}
                    label='1st Fortnight'
                  />
                  <FormControlLabel
                    value='second'
                    control={<Radio />}
                    label='2nd Fortnight'
                  />
                </RadioGroup>
              </FormControl>

              <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label='Start Date*'
                    value={toDayjs(startDate)} // convert string -> Dayjs
                    format='YYYY/MM/DD' // v6
                    onChange={(data) => formatDate(data)}
                    disableFuture={false}
                    readOnly
                    sx={{ width: '100%' }}
                  />
                </LocalizationProvider>
              </FormControl>

              <FormControl fullWidth sx={{ mt: 2 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label='End Date*'
                    value={toDayjs(endDate)} // convert string -> Dayjs
                    disabled={!dateRange || loading}
                    format='YYYY/MM/DD' // v6
                    minDate={minDate} // Dayjs
                    maxDate={
                      startDate ? dayjs(startDate).add(15, 'day') : undefined
                    }
                    onChange={(data) => {
                      const selected = dayjs(data?.$d ?? data);
                      setEndDate(fmt(selected)); // store as string
                    }}
                    disableFuture={false}
                    readOnly
                    sx={{ width: '100%' }}
                  />
                </LocalizationProvider>
              </FormControl>
              {/* <FormControl fullWidth>
                <Autocomplete
                  size='small'
                  value={selectedExpenseOwnerD || null}
                  onChange={(event, newValue) =>
                    handleExpenseOwnerDChange(newValue)
                  }
                  options={eventTeams1}
                  getOptionLabel={(option) =>
                    typeof option === 'string' ? option : option?.name__c || ''
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.name__c === value
                  }
                  fullWidth
                  autoComplete='off'
                  loading={searchLoading1}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label='Expense Owner'
                      onChange={(event) =>
                        debouncedSearchField(event, 'Expense Owner')
                      }
                      slotProps={{
                        input: {
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {searchLoading1 && (
                                <CircularProgress color='inherit' size={20} />
                              )}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        },
                      }}
                    />
                  )}
                  filterOptions={(options, state) => {
                    return options.filter((option) =>
                      option.name__c.toLowerCase()
                    );
                  }}
                />
              </FormControl> */}

              <FlexContainer
                style={{
                  justifyContent: 'center',
                  width: '100%',
                  gap: 30,
                  marginTop: '20px',
                }}
              >
                <Button variant='outlined' onClick={handleClose3}>
                  Cancel
                </Button>
                <Button variant='contained' onClick={downloadReportInChunks}>
                  Download
                </Button>
              </FlexContainer>
            </DialogContainer>
          </DialogContent>
        </Dialog>

        <div ref={loaderRef} style={{ height: '50px' }} />

        {spinLoading && pageNumber > 1 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: '20px',
            }}
          >
            <CircularProgress />
          </div>
        )}
      </Container>
    </div>
  );
};

export default ApprovalExpense;
